export const RELOAD_HOT_KEY_MACOS = 'meta+s';
export const RELOAD_HOT_KEY_WINDOWS_OR_LINUX = 'ctrl+s';
export const RUN_CODE_HOT_KEY_CODEMIRROR_WINDOWS_OR_LINUX = 'ctrl-s';
export const RUN_CODE_HOT_KEY_CODEMIRROR_MAC = 'meta-s';
